module.exports = __webpack_public_path__ + "media/images/icon-question-mark-gray-dc8b4f512acb573f1e7696e95b4ef19f.svg";